import React, { memo } from 'react';
import {
    HandleChangeVisible,
    IFormField,
    IFormPresentation,
    SelectTypes,
    SelectValue
} from '../schema/interface';
import DateTimeInput from './InputFields/DateTimeInput';
import LongTextInput from './InputFields/LongTextInput';
import MediaInput from './InputFields/MediaInput';
import NumberInput from './InputFields/NumberInput';
import TextInput from './InputFields/TextInput';
import MultiSelect from './InputFields/SelectField/MultiSelect';
import SingleSelect from './InputFields/SelectField/SingleSelect';
import GroupOverView from './InputFields/GroupOverView';

type IInputControl = {
    type: string;
    metadata: any;
    presentation: IFormPresentation;
    name: string;
    value: string | string[] | SelectValue;
    uploadMedia: Function;
    label?: string;
    field: IFormField;
    handleChangeVisible: HandleChangeVisible;
    formValues: { [key: string]: string | string[] | SelectValue };
    noAccess?: boolean;
};
const InputControl = ({
    type,
    metadata,
    presentation,
    name,
    value,
    uploadMedia,
    label,
    field,
    handleChangeVisible,
    formValues,
    noAccess
}: IInputControl) => {
    const { invisible } = presentation;
    if (invisible) {
        return null;
    }
    switch (type) {
        case 'group': {
            return (
                <GroupOverView
                    field={field}
                    uploadMedia={uploadMedia}
                    handleChangeVisible={handleChangeVisible}
                    noAccess={noAccess}
                />
            );
        }
        case 'id':
        case 'char': {
            return (
                <TextInput
                    value={value as string}
                    name={name}
                    metadata={metadata}
                    presentation={presentation}
                    handleChangeVisible={handleChangeVisible}
                    formValues={formValues}
                    noAccess={noAccess}
                />
            );
        }
        case 'text': {
            return (
                <LongTextInput
                    value={value as string}
                    name={name}
                    metadata={metadata}
                    presentation={presentation}
                    handleChangeVisible={handleChangeVisible}
                    formValues={formValues}
                    noAccess={noAccess}
                />
            );
        }

        case 'integer':
        case 'float': {
            return (
                <NumberInput
                    name={name}
                    value={value as string}
                    metadata={metadata}
                    presentation={presentation}
                    handleChangeVisible={handleChangeVisible}
                    formValues={formValues}
                    noAccess={noAccess}
                />
            );
        }
        case 'datetime': {
            return (
                <DateTimeInput
                    hasTime
                    value={value.toString()}
                    name={name}
                    presentation={presentation}
                    handleChangeVisible={handleChangeVisible}
                    formValues={formValues}
                    noAccess={noAccess}
                />
            );
        }
        case 'date': {
            return (
                <DateTimeInput
                    hasTime={false}
                    value={value.toString()}
                    name={name}
                    presentation={presentation}
                    handleChangeVisible={handleChangeVisible}
                    formValues={formValues}
                    noAccess={noAccess}
                />
            );
        }
        case 'select': {
            if (
                presentation?.selectType === SelectTypes.multi ||
                presentation?.selectType === SelectTypes.Boolean
            ) {
                return (
                    <MultiSelect
                        presentation={presentation}
                        value={value as SelectValue}
                        metadata={metadata}
                        name={name}
                        handleChangeVisible={handleChangeVisible}
                        formValues={formValues}
                        noAccess={noAccess}
                    />
                );
            }
            return (
                <SingleSelect
                    presentation={presentation}
                    value={value as SelectValue}
                    metadata={metadata}
                    name={name}
                    handleChangeVisible={handleChangeVisible}
                    formValues={formValues}
                    noAccess={noAccess}
                />
            );
        }
        case 'file': {
            return (
                <MediaInput
                    value={value as string}
                    label={label}
                    name={name}
                    uploadMedia={uploadMedia}
                    presentation={presentation}
                    noAccess={noAccess}
                />
            );
        }
        default:
            return null;
    }
};
export default memo(InputControl);
